import {
  Obj
} from '../Object.lib';
import {
  COLLECTION__JOBS,
  readLoopbackRecord
} from '../services/BE/loopback.api';
import {
  trim
} from '../String.lib';

const cache = {};
export default async function fetchJobTitle({
  jobId
}) {
  try {
    if (cache[jobId]) {
      return cache[jobId];
    }
    return (
      cache[jobId] = trim(
        Obj(
          await readLoopbackRecord({
            collection: COLLECTION__JOBS,
            where: { id: jobId },
            fields: ['jobTitle'],
            limit: 1
          })
        ).jobTitle
      )
    );
  }
  catch (error) {
    console.error(error);
  }
  return '';
}
